import { API_METHODS } from 'config/constants';

export const PROFILE_ACTION_TYPES = {
  PROFILE_SET_DATA_BY_KEY: 'PROFILE_SET_DATA_BY_KEY',
  PROFILE_CHANGE_PROCESSING: 'PROFILE_CHANGE_PROCESSING',
  PROFILE_CLEAR_STATE: 'PROFILE_CLEAR_STATE',
};

export function getRepresentativeProfile(
  pageObject,
  stateKeyForDataSaving,
  userProfileId,
) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProfileProcessingState(true, 'representativeProfile'));

    const response = await axios.get(
      `${API_METHODS.REPRESENTATIVE}/${userProfileId}`,
    );

    dispatch(changeProfileProcessingState(false, 'representativeProfile'));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data, hasAccess } = response;
    data.hasAccess = hasAccess;
    dispatch(setProfileDataByKey(data, stateKeyForDataSaving));

    return response;
  };
}

export function setProfileDataByKey(data, stateKeyForDataSaving) {
  return {
    type: PROFILE_ACTION_TYPES.PROFILE_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function clearProfileState(clearedKey, shouldDeleteProperty = false) {
  return {
    type: PROFILE_ACTION_TYPES.PROFILE_CLEAR_STATE,
    payload: {
      clearedKey,
      shouldDeleteProperty,
    },
  };
}

export function changeProfileProcessingState(newState, processingDestination) {
  return {
    type: PROFILE_ACTION_TYPES.PROFILE_CHANGE_PROCESSING,
    payload: { newState, processingDestination },
  };
}

export function getProfileData(
  pageObject,
  stateKeyForDataSaving,
  methodUrl,
  processingKey,
) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProfileProcessingState(true, processingKey));

    const response = await axios.get(methodUrl);

    dispatch(changeProfileProcessingState(false, processingKey));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data = {}, accessRequest } = response;

    dispatch(setProfileDataByKey(data, stateKeyForDataSaving));

    if (accessRequest !== undefined) {
      dispatch(setProfileDataByKey(accessRequest, 'accessRequest'));
    }

    return response;
  };
}

export function getRepresentativeClinicalQualification(
  userId,
  stateKeyForDataSaving,
  processingKey,
) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProfileProcessingState(true, processingKey));

    const response = await axios.get(
      API_METHODS.REPRESENTATIVE_CLINICAL_QUALIFICATION(userId),
    );

    dispatch(changeProfileProcessingState(false, processingKey));

    const { data } = response;

    dispatch(
      setProfileDataByKey(
        { isClinicallyQualified: data },
        stateKeyForDataSaving,
      ),
    );

    return response;
  };
}
